import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgMdiInstagram = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 29 29"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path fill="transparent" d="M.5.5h28v28H.5z" />
    <path
      fill="currentColor"
      d="M9.6 2.834h9.8A6.77 6.77 0 0 1 26.167 9.6v9.8a6.767 6.767 0 0 1-6.767 6.767H9.6A6.77 6.77 0 0 1 2.833 19.4V9.6A6.767 6.767 0 0 1 9.6 2.834m-.233 2.333a4.2 4.2 0 0 0-4.2 4.2v10.267c0 2.321 1.878 4.2 4.2 4.2h10.266a4.2 4.2 0 0 0 4.2-4.2V9.367c0-2.322-1.878-4.2-4.2-4.2zm11.258 1.75a1.458 1.458 0 1 1 0 2.916 1.458 1.458 0 0 1 0-2.916M14.5 8.667a5.833 5.833 0 1 1 0 11.666 5.833 5.833 0 0 1 0-11.666m0 2.333a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7"
    />
  </svg>
);
export default SvgMdiInstagram;
